<style lang="less" scoped>
    .print-container{
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        font-size: 12px;
        z-index: 10000;
        color: #000;
        background: white;
    }
    .bill-container {
      width: 680px;
      padding-top: 100px;
      padding-bottom: 100px;
      position: absolute;
      margin: 0 auto;
      left: 0;
      right: 0;
      display: flex;
      align-items: center;
      flex-flow: column;
      & > .title {
        font-size: 16px;
        width: 600px;
        position: relative;
        text-align: center;
        & > .uid {
          font-size: 12px;
          right: -20px;
          position: absolute;
        }
      }
      & > .sub-title {
        font-size: 24px;
      }
      .bill-detail {
        margin-top: 50px;
        display: flex;
        width: 600px;
        justify-content: space-between
      }
      .bill-list {
        margin-top: 50px;
        border-left: 1px solid black;
        border-bottom: 1px solid black;
        border-top: 1px solid black;
        display: flex;
        flex-flow: column;
        align-items: center;
        text-align: center;
        .item-title {
          display: flex;
          & > div {
            width: 200px;
            border-right: 1px solid black;
            border-bottom: 1px solid black;
          }
        }
        .item {
          display: flex;
          & > div {
            width: 200px;
            border-right: 1px solid black;
          }
        }
      }
    }
    .close-editor-btn{
        position: absolute;
        top: 20px;
        right: 20px;
        z-index: 999;
    }
    @media print {
        .close-editor-btn{
            display: none;
        }
    }
    .print-content{
        display: inline-block;
        width: 182mm;
        /*height: 280mm;*/
        text-align: center;
        line-height: 14px;
        padding: 5mm 3mm;
        box-sizing: content-box;
    }
    table{
        width: 100%;
    }
    .ivu-table-wrapper{
        border-color: #666;
    }
    .ivu-table:after, .ivu-table:before {
        content: "";
        display: none;
    }
    .ivu-table td{
        height: 40px;
        padding: 0 12px;
        text-align: center;
        word-wrap: break-word;
        width: 25%;
        border-color: #666;
    }
    .asset-extra{
        display: block;
        white-space: pre-line;
        text-align: left;
    }
</style>
<template>
    <div class="print-container" v-show="is_show">
        <div class="close-editor-btn">
            <Button type="primary" @click="rePrint" icon="md-print">打印</Button>
            <Button type="warning" @click="close" icon="md-close">关闭</Button>
        </div>
        <div class="bill-container">
          <div class="title">
            <span>{{bill.bill_company}}</span>
            <span class="uid">Invoice {{bill.uid}}</span>
          </div>
          <div class="sub-title">INVOICE</div>
          <div class="bill-detail">
            <div class="bill-company">
              <div class="title">BILL TO</div>
              <div class="content">{{bill.send_company}}</div>
            </div>
            <div class="bill-date">
              <div class="title">DATE</div>
              <div class="content">{{getForeginDate(bill.date)}}</div>
            </div>
          </div>
          <div class="bill-list">
            <div class="item-title">
                <div class="no">MARKS&NO.</div>
                <div class="desc">DESCRIPTION</div>
                <div class="amount">AMOUNT</div>
            </div>
            <div class="item" v-for="item in bill.items" :key="item.id">
              <div class="no">{{item.no}}</div>
              <div class="desc">
                {{item.desc}}
              </div>
              <div class="amount">
                {{price_unit_hash[bill.price_unit]}} {{item.amount}}
              </div>
            </div>
            <div class="item">
                <div class="no"></div>
                <div class="desc">TOTAL</div>
                <div class="amount">{{price_unit_hash[bill.price_unit]}} {{amount}}</div>
            </div>
          </div>
          <div></div>
        </div>
    </div>
</template>
<script>
    import Util from '../../../libs/util'
    import html2canvas from 'html2canvas'
    export default {
        data () {
            return {
                is_show: false,
                bill: {},
                price_unit_hash: {
                  0: '$',
                  1: '€',
                  2: 'C$',
                  3: 'A$',
                  4: '£',
                  5: '¥'
                }
            }
        },
        computed: {
            cur_customer(){
                return this.$store.state.cur_customer;
            },
            asset(){
                return this.assets[0];
            },
            customer_account(){
                if(this.asset.asset_customer && this.asset.asset_customer.customer){
                    return this.asset.asset_customer.customer.account;
                }else{
                    return '';
                }
            },
            customer_uid(){
                if(this.asset.asset_customer && this.asset.asset_customer.customer){
                    return this.asset.asset_customer.customer.uid || '';
                }else{
                    return '';
                }
            },
            customer_team(){
                if(this.asset.asset_customer && this.asset.asset_customer.customer && this.asset.asset_customer.customer.team_id){
                    return this.asset.asset_customer.customer.team;
                }else{
                    return '';
                }
            },
            customer_job(){
                if(this.asset.asset_customer && this.asset.asset_customer.customer && this.asset.asset_customer.customer.job_id){
                    return this.asset.asset_customer.customer.job;
                }else{
                    return '';
                }
            },
            amount () {
              if (this.bill.items) {
                return this.bill.items.reduce((acc, cur) => {
                  acc += parseFloat(cur.amount)
                  return acc
                }, 0).toFixed(2)
              } else {
                return 0
              }
            }
        },
        created(){
            //
        },
        mounted(){
            //
        },
        methods: {
            generateJpg () {
              const dom = document.querySelector('.bill-container')
              const width = dom.offsetWidth
              const height = dom.offsetHeight
              html2canvas(dom, {scale: 1,  width, height}).then(canvas => {
                // var a = document.createElement('a');
                // // toDataURL defaults to png, so we need to request a jpeg, then convert for file download.
                // a.href = canvas.toDataURL("image/jpeg").replace("image/jpeg", "image/octet-stream");
                // a.download = 'somefilename.jpg';
                // a.click();
                canvas.toBlob((blob) => {
                  const total_price = this.bill.items.reduce((acc, cur) => {
                    acc += parseFloat(cur.amount)
                    return acc
                  }, 0).toFixed(2)
                  // this.$util.ajax.post(this.$util.api.update_invoice, {
                  //   invoice_type: 9,
                  //   uid: this.bill.uid,
                  //   total_price: total_price,
                  //   invoice_date: this.bill.date
                  // }).then(() => {
                  //   this.queryRecentGenerateInvoiceNumber()
                  // })
                  const formData = new FormData()
                  formData.append('file', blob, 'invoice_generate_' + this.bill.uid.slice(1, this.bill.uid.length) + '.jpg')
                  formData.append('invoice_type', 9)
                  formData.append('uid', this.bill.uid)
                  formData.append('total_price', total_price)
                  formData.append('invoice_date', this.bill.date)
                  formData.append('width', width)
                  formData.append('height', height)
                  Util.ajax({
                      method: 'post',
                      url: Util.api.update_generate_invoice,
                      data: formData,
                      headers: {
                          'Content-Type': 'multipart/form-data'
                      }
                  }).then(() => {
                    this.$emit('generated')
                  })
                }, 'image/jpeg', 0.95)
              })
            },
            print(bill){
              this.bill = bill;
              this.is_show = true;
              //Object.assign(this.asset, asset);
              setTimeout(()=>{
                  this.generateJpg()
                  window.print();
              }, 800);
            },
            rePrint(){
                window.print();
            },
            getForeginDate(date) {
              if (date) {
                const month_hash = {
                  '01': 'Jan',
                  '02': 'Feb',
                  '03': 'Mar',
                  '04': 'Apr',
                  '05': 'May',
                  '06': 'Jun',
                  '07': 'Jul',
                  '08': 'Aug',
                  '09': 'Sep',
                  '10': 'Oct',
                  '11': 'Nov',
                  '12': 'Dec'
                }
                const date_arr = date.split('-')
                return `${date_arr[2]}th, ${month_hash[date_arr[1]]}, ${date_arr[0]}`
              }
            },
            close(){
                this.is_show = false;
            }
        }
    }
</script>
